import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Collapse,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MainCard from "../../../../components/Maincard";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import CustomSmallChip from "../../../newComponent/CustomChip/CustomSmallChip";
import CustomAutocompleteComp from "../../../newComponent/AutocompleteComp";
import CustomTextFieldComp from "../../../newComponent/customTextFieldComp";
import SearchButton from "../../../newComponent/NewButtonComp/SearchButton";
import ClearButtonComp from "../../../newComponent/NewButtonComp/ResetButtonComp";
import SearchTextFieldComp from "../../../newComponent/newtextfieldComp/SearchTextFieldComp";
import CustomSnackbar from "../../../components/ui-component/snackbar/CustomSnackbar";
import { useGetTokenOrLogout } from "../../../../utils/token";
import { useNavigate } from "react-router-dom";
import LoaderComp from "../../../newComponent/LoaderComp/Loader";
import CustomPopup from "../../../../components/CustomPopup";
import RecycleRequestHyperlink from "./RecycleRequestHyperlink";
import { CSVExport } from "../../../components/ui-component/table/CSVExport";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function RecycleCampaignWise({ open,isDownloadAccess }) {
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const getTokenOrLogout = useGetTokenOrLogout();
  const navigate = useNavigate();
  const [recycleData, setRecyCleData] = useState([]);
  const [SearchData, setSearchData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [subServiceName, setSubServiceName] = useState([]);
  const [subServiceList, setSubsubServiceList] = useState([]);
  const [selectedButton, setSelectedButton] = useState(null);
  const [selectedDuration, setSelectedDuration] = useState(null);
  const [campaignList, setCampaignList] = useState([]);
  const [campaignname, setCampaignName] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [eventFromDate, setEventFromDate] = useState(null);
  const [eventToDate, setEventToDate] = useState(null);
  const [loading, setloading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setTodate] = useState("");
  const [filterType, setFilterType] = useState("today");
  const [dataLading, setDataLoading] = useState(false);
  const [detailesLoading, setDetailsLoading] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [detailsData, setDetailsData] = useState([]);
  const [rowData, setRowData] = useState({});
    const [exportData, setExportData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const noOptionsText = "Loading...";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subservice`);
        if (response.ok) {
          const data = await response.json();

          setSubsubServiceList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allSubservice = [{ name: "Select All", id: 0 }, ...subServiceList];

  // handle subservice
  const handleChangeSubservice = (id) => {
    setSelectedButton(null);
    setCampaignList([]);
    setCampaignName([]);
    setSelectedDuration(null);
    if (id === 0) {
      // Handle "Select All"
      setSubServiceName(
        (prevSelected) =>
          prevSelected.length === subServiceList.length
            ? [] // Deselect all
            : subServiceList.map((subservice) => subservice.id) // Select all
      );
    } else {
      // Handle individual subservice selection
      setSubServiceName(
        (prevSelected) =>
          prevSelected.includes(id)
            ? prevSelected.filter((subserviceId) => subserviceId !== id) // Remove ID if already selected
            : [...prevSelected, id] // Add ID if not selected
      );
    }
  };

  // campaign type
  const handleChipClick = async (criteria) => {
    setSelectedButton(criteria);
    setCampaignName([]);
    setCampaignList([]);
    setSelectedYear("");
    setEventFromDate(null);
    setEventToDate(null);

    setSelectedDuration("");
  };

  const handlDurationchange = async (criteria) => {
    setCampaignName([]);
    setCampaignList([]);
    setSelectedYear("");
    setSelectedDuration(criteria);
    setEventFromDate(null);
    setEventToDate(null);
    if (criteria === "customyear" || criteria === "customdate") {
      return;
    }

    getCampaignData(selectedButton, criteria, null, null, null);
  };

  const years = Array.from(
    { length: 5 },
    (_, index) => new Date().getFullYear() - 3 + index
  );

  const handleselectedYear = async (value) => {
    setSelectedYear(value);

    getCampaignData(selectedButton, selectedDuration, value);
  };

  const handleCustomFilter = () => {
    getCampaignData(
      selectedButton,
      selectedDuration,
      null,
      eventFromDate,
      eventToDate
    );
  };

  const getCampaignData = async (
    selectedButton,
    duration,
    criteria,
    fromDate,
    toDate
  ) => {
    setloading(true);
    setCampaignName([]);
    setCampaignList([]);
    const requestData = {
      campaign_type: selectedButton,
      duration: duration,
      year: criteria,
      sub_service_id: subServiceName,
      from_date: fromDate,
      to_date: toDate,
    };

    try {
      const response = await fetch(`${API_ENDPOINT}route2.0/searchcampaign`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        setloading(false);
        const result = await response.json();
        const sortedData = result.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setCampaignList(sortedData);
      } else if (response.status === 401) {
        // Handle errors, e.g., show an error message
      } else if (response.status === 404) {
        setloading(false);
        setCampaignList([]);
      } else {
        setloading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setloading(false);
    }
  };

  const allcampaignList = [
    ...(campaignList.length > 1 ? [{ campaign_name: "Select All" }] : []),
    ...campaignList,
  ];

  const handleCampaignChange = (event, value) => {
    // Check if "Select All" is selected
    if (value.some((option) => option.campaign_name === "Select All")) {
      // If "Select All" is already selected, remove it from the selection
      if (
        campaignname.some((option) => option.campaign_name === "Select All")
      ) {
        setCampaignName([]);
      } else {
        // Otherwise, select all options
        setCampaignName(campaignList);
      }
    } else {
      setCampaignName(value);
    }
  };

  const handleFilterChange = (event) => {
    setFilterType(event.target.value);
  };

  const handleSearchData = async (event) => {
   
    if ( campaignname.length===0) {
      showSnackbar('Please select campaign name' , 'error')
      return;
    }
    setDataLoading(true);

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      campaign_id: campaignname.map((i) => i.id),
      filter: filterType,
      user_id: parseInt(userId),
      recycle_from_date: fromDate || null,
      recycle_to_date: toDate || null,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}route2.0/campaignwise-recycle`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      const result = await response.json();
      if (response.ok) {
        setDataLoading(false);

        setRecyCleData(result);
        setSearchData(result);
      } else if (response.status === 404) {
        navigate("/page404");
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/page403");
      } else if (response.status === 400) {
        setDataLoading(false);
        showSnackbar(result.message, "error");
        setRecyCleData([]);
      } else {
        navigate("/page500");
      }
    } catch {
      navigate("/page500");
    }
  };

  const resetFilter = () => {
    setCampaignName([]);

    setRecyCleData([]);
    setSearchData([]);
    setSelectedButton("");
    setSelectedDuration("");
    setSelectedYear("");
    setCampaignList([]);

    setSubServiceName([]);
    setEventFromDate(null);
    setEventToDate(null);
    setFromDate("");
    setTodate("");
    setFilterType("today");
  };

  const columns = [
    {
      field: "campaign_name",
      headerName: "Camapign Name",
      flex: 1,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
       valueGetter: (params) =>
        params.row?.campaign_name || "" ,
      renderCell: (params) => {
              const isLastRow=params?.row?.campaign_name==="Total"
        return (
       
        <div style={{
              color: isLastRow ? "black" : "",
              fontSize:isLastRow ? '0.8rem' :'0.7rem' ,

              fontWeight: isLastRow ? 700 : 500,
            }}>
          {params.row?.campaign_name}
        </div>
      )},
    },
    {
      field: "recycled_enq",
      headerName: " Recycle Enquiry",
      flex: 1,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",

      renderCell: (params) =>  {
         const isLastRow=params?.row?.campaign_name==="Total"
        return(

        <div
         style={{
              color: isLastRow ? "black" : "blue",
              cursor:  !isLastRow ?"pointer" :null,
              fontWeight: isLastRow ? 700 : 500,
                fontSize:isLastRow ? '0.8rem' :'0.7rem' ,
            }}
          onClick={() =>!isLastRow ?  handleSearchDetailsData(params.row) :undefined}
        >
          {params.row?.recycled_enq}{" "}
        </div>
      )},
    },
  ];

  const handleSearchByName = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = SearchData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data?.campaign_name || ""}`,
        `${data?.recycled_enq || ""}`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value)
      );
    });

    setRecyCleData(filteredData1); // Update the filtered data
  };

  // Details Data
  const handleOpenPopup = (rowData) => {
    setDetailsOpen(true);
    setRowData(rowData);
  };

  const handleClosePopup = () => {
    setDetailsOpen(false);
  };

  const handleSearchDetailsData = async (rowData) => {
    setDetailsLoading(true);

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      campaign_id: rowData?.id,
      filter: filterType,
      user_id: parseInt(userId),
      recycle_from_date: fromDate || null,
      recycle_to_date: toDate || null,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}route2.0/campaignwise-recycle-with-detail`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      const result = await response.json();
      if (response.ok) {
        setDetailsLoading(false);

        setDetailsData(result);
        setSearchData(result);
        handleOpenPopup(rowData);
      } else if (response.status === 404) {
        navigate("/page404");
      } else if (response.status === 401) {
        navigate("Unknown User", "error");
      } else if (response.status === 403) {
        navigate("Unathorized User", "error");
      } else if (response.status === 400) {
        setDetailsLoading(false);
        showSnackbar(result.message, "error");
        setDetailsData([]);
      } else {
        showSnackbar("Server Error", "error");
        setDetailsLoading(false);
      }
    } catch {
      showSnackbar("Server Error", "error");
      setDetailsLoading(false);
    }
  };

    // Export Data
  
    useEffect(() => {
      const exportData = recycleData.map((row) => ({
       lead_owner:row?.campaign_name,
       recycle_enquiry : row?.recycled_enq
      }));
      setExportData(exportData);
    }, [recycleData]);
  return (
    <>
      <LoaderComp isLoading={dataLading || detailesLoading} />
      <Grid container spacing={2}>
        {/* Filter Ui */}
        <Grid item xs={12}>
          <Collapse in={open}>
            <MainCard>
              <Grid container spacing={2}>
                {/* Sub service  */}
                <Grid item xs={12}>
                  <Typography
                    variant="h4"
                    sx={{
                      color: "#2E4069",

                      fontWeight: 600,
                      marginTop: "20px",
                    }}
                  >
                    Sub Service
                  </Typography>

                  {allSubservice.map((subservice) => (
                    <Chip
                      size="small"
                      key={subservice.id}
                      onClick={() => handleChangeSubservice(subservice.id)}
                      variant="outlined"
                      label={
                        subservice.id === 0
                          ? subServiceName.length === subServiceList.length
                            ? "Deselect All"
                            : "Select All"
                          : subservice.name
                      }
                      style={{
                        color: subServiceName.includes(subservice.id)
                          ? "green"
                          : "black",
                        fontSize: "0.7rem",
                        fontWeight: 500,
                        margin: "5px",
                        border: subServiceName.includes(subservice.id)
                          ? "2px solid green"
                          : "",
                      }}
                    />
                  ))}
                </Grid>

                {/* Campaign Type */}

                <Grid item xs={12} lg={12} sm={12} md={12}>
                  <Typography
                    variant="h4"
                    sx={{ color: "#2E4069", fontWeight: 600 }}
                  >
                    Campaign Type
                    <span
                      style={{
                        color: "red",
                        fontSize: "15px",
                        marginLeft: "3px",
                      }}
                    >
                      *
                    </span>
                  </Typography>
                  <Box mt={1}>
                    <CustomSmallChip
                      label="All"
                      onClick={() => handleChipClick("all")}
                      isSelected={selectedButton === "all"}
                    />

                    <CustomSmallChip
                      label="Event"
                      onClick={() => handleChipClick("Event")}
                      isSelected={selectedButton === "Event"}
                    />

                    <CustomSmallChip
                      label="Generic"
                      onClick={() => handleChipClick("Generic")}
                      isSelected={selectedButton === "Generic"}
                    />
                  </Box>
                </Grid>

                {/* Duration */}
                <Grid item xs={12} lg={12} sm={12} md={12}>
                  <Typography
                    variant="h4"
                    sx={{
                      color: "#2E4069",

                      fontWeight: 600,
                    }}
                  >
                    Duration
                    <span
                      style={{
                        color: "red",
                        fontSize: "15px",
                        marginLeft: "3px",
                      }}
                    >
                      *
                    </span>
                  </Typography>
                  <Grid container>
                    <Box
                      mt={1}
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                      }}
                    >
                      <CustomSmallChip
                        label="All"
                        onClick={() => handlDurationchange("all")}
                        isSelected={selectedDuration === "all"}
                      />

                      <CustomSmallChip
                        label="Past"
                        onClick={() => handlDurationchange("past")}
                        isSelected={selectedDuration === "past"}
                      />

                      <CustomSmallChip
                        label="Running"
                        onClick={() => handlDurationchange("running")}
                        isSelected={selectedDuration === "running"}
                      />
                      <CustomSmallChip
                        label="Upcoming"
                        onClick={() => handlDurationchange("upcoming")}
                        isSelected={selectedDuration === "upcoming"}
                      />
                      {/* <CustomSmallChip
                      label="Custom Year"
                      onClick={() => handlDurationchange("customyear")}
                      isSelected={selectedDuration === "customyear"}
                    />
                    {selectedDuration === "customyear" && (
                      <CustomAutocompleteComp
                        value={selectedYear}
                        onChange={(event, value) => handleselectedYear(value)}
                        sx={{ width: "300px" }}
                        options={years}
                      />
                    )} */}
                      <CustomSmallChip
                        label="Custom Date"
                        onClick={() => handlDurationchange("customdate")}
                        isSelected={selectedDuration === "customdate"}
                      />

                      {selectedDuration === "customdate" && (
                        <>
                          <CustomTextFieldComp
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            size="small"
                            sx={{ margin: "5px" }}
                            type="date"
                            label="From Date"
                            value={eventFromDate}
                            InputProps={{ style: { borderRadius: "14px" } }}
                            onChange={(e) => setEventFromDate(e.target.value)}
                          />

                          <CustomTextFieldComp
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            size="small"
                            sx={{ margin: "5px" }}
                            type="date"
                            label="To Date"
                            value={eventToDate}
                            onChange={(e) => setEventToDate(e.target.value)}
                            InputProps={{ style: { borderRadius: "14px" } }}
                          />

                          <Button
                            size="small"
                            color="primary"
                            variant="contained"
                            sx={{ margin: "5px" }}
                            onClick={handleCustomFilter}
                            disabled={!eventFromDate || !eventToDate}
                          >
                            Apply
                          </Button>
                        </>
                      )}
                    </Box>
                  </Grid>
                </Grid>

                <Grid item xs={12} lg={3} md={6} sm={6}>
                  <Typography variant="h6">Campaign</Typography>
                  <CustomAutocompleteComp
                    limitTags={1}
                    noOptionsText={
                      loading && allcampaignList.length === 0
                        ? noOptionsText
                        : "Please Select Above Filter First"
                    }
                    multiple
                    value={campaignname}
                    onChange={handleCampaignChange}
                    options={allcampaignList}
                    getOptionLabel={(option) => option.campaign_name}
                    tooltipContent={(option) => option.campaign_name}
                    endAdornment={
                      <>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                      </>
                    }
                  />
                </Grid>

                <Grid item xs={12} lg={2} md={4} sm={6}>
                  <Typography variant="h6">Recycle Date Filter</Typography>
                  <Select
                    value={filterType}
                    onChange={handleFilterChange}
                    fullWidth
                    style={{ borderRadius: "10px" }}
                    size="medium"
                  >
                    <MenuItem value="today">Today</MenuItem>
                    <MenuItem value="currentweek">This Week</MenuItem>
                    <MenuItem value="currentmonth">This Month</MenuItem>
                    <MenuItem value="custom">Custom</MenuItem>
                  </Select>
                </Grid>

                {filterType === "custom" && (
                  <>
                    <Grid item xs={12} lg={2} md={4} sm={6}>
                      <Typography variant="h6"> Recycle Date From</Typography>
                      <CustomTextFieldComp
                        size="normal"
                        fullWidth
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        InputProps={{
                          style: { borderRadius: "10px" },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} lg={2} md={4} sm={6}>
                      <Typography variant="h6"> Recycle Date To</Typography>
                      <CustomTextFieldComp
                        size="normal"
                        fullWidth
                        type="date"
                        value={toDate}
                        onChange={(e) => setTodate(e.target.value)}
                        InputProps={{
                          style: { borderRadius: "10px" },
                        }}
                      />
                    </Grid>
                  </>
                )}

                <Grid item xs={12} md={12} lg={12} sm={12} textAlign="end">
                  <Grid container gap={2} justifyContent="end">
                    <SearchButton
                      label="Search"
                      onClick={handleSearchData}
                      showIcon={true}
                    />

                    <ClearButtonComp label="Clear" onClick={resetFilter} />
                  </Grid>
                </Grid>
              </Grid>
            </MainCard>
          </Collapse>
        </Grid>
        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid
                                            item
                                            xs={12}
                                          
                                            container
                                            justifyContent="end"
                                            alignItems="center"
                                            gap={1}
                                          >
                                            <SearchTextFieldComp onChange={handleSearchByName} />
                                            {isDownloadAccess && (
                                              <CSVExport
                                                data={exportData}
                                                filename="recycle-enquiry-report.csv"
                                              />
                                            )}
                                          </Grid>
              <Grid item xs={12}>
                <DataGrid
                  rows={recycleData}
                  columns={columns}
                  autoHeight
                  slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 25,
                      },
                    },
                  }}
                  pageSizeOptions={[25, 50, 100]}
                  disableRowSelectionOnClick
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>
      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <CustomPopup
        open={detailsOpen}
        onClose={handleClosePopup}
        component={
          <RecycleRequestHyperlink
            detailsData={detailsData}
            rowData={rowData}
            filterType={filterType}
            fromDate={fromDate}
            toDate={toDate}
            userWise={false}
            isDownloadAccess={isDownloadAccess}
          />
        }
        title="Recycle Enquiry Details "
        maxWidth="lg"
        showDivider={true}
      />
    </>
  );
}
